import "client-only"
import { withDebounce } from "@/utilities/debounce/with-debounce"

const definedBreakpoints = ["xs", "sm", "md", "lg", "xl", "2xl", "3xl"] as const
const debounceDelay = 150

export type BreakpointValues = (typeof definedBreakpoints)[number]

export type Viewport = {
  readonly currentBreakpoint: BreakpointValues | null
  readonly isMobile: boolean
  readonly isDesktop: boolean
  readonly isTablet: boolean
  readonly is3XlDesktop: boolean
}

export const viewportStore = {
  getServerSnapshot: (): BreakpointValues | null => null,

  getSnapshot: (): BreakpointValues | null => {
    const breakpoint = window
      .getComputedStyle(document.body, ":before")
      .content.replace(/"/g, "") as BreakpointValues

    return definedBreakpoints.includes(breakpoint) ? breakpoint : null
  },

  subscribe: (callback: () => void): (() => void) => {
    const debouncedCallback = withDebounce(callback, debounceDelay)

    window.addEventListener("resize", debouncedCallback)

    return () => {
      window.removeEventListener("resize", debouncedCallback)
    }
  },
}
